/** Poster list layout (thumbnail — same size as exploitation /screenings). */
export const POSTER_LIST_VARIANT = 'thumbnail';

export const POSTER_LIST_VARIANT_PROGRAMMATIONS = POSTER_LIST_VARIANT;
export const POSTER_LIST_VARIANT_SCREENINGS = POSTER_LIST_VARIANT;
